import { useHistory } from 'react-router-dom';
import { useState } from 'react';

const useListHook = (initialValues) => {
  const history = useHistory();
  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(initialValues?.totalCount || 0);
  const [fulltextFilter, setFulltextFilter] = useState(initialValues?.fulltext);
  const [columnsFilter, setColumnsFilter] = useState(initialValues?.filters || {});
  const [orderDirection, setOrderDirection] = useState(initialValues?.order);
  const [orderByColumn, setOrderByColumn] = useState(initialValues?.orderBy);
  const [page, setPage] = useState(initialValues.page);
  const [rowsPerPage, setRowsPerPage] = useState(initialValues.rowsPerPage);
  const [filterOptions, setFilterOptions] = useState(initialValues?.filterOptions || {});

  return {
    history,
    rows,
    totalCount,
    filterOptions,
    fulltextFilter,
    columnsFilter,
    orderDirection,
    orderByColumn,
    page,
    rowsPerPage,
    setRows,
    setTotalCount,
    setFilterOptions,
    setFulltextFilter,
    setColumnsFilter,
    setOrderDirection,
    setOrderByColumn,
    setPage,
    setRowsPerPage,
  };
};

export default useListHook;
